var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Checkbox, Col, ErrorModal, MessageBanner, Modal, Pane, PaneFooter, Row, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { RecekTextField } from "../../components/inputs";
import { declareLastUsedNumber, fetchPublisherPrefixById, } from "../../api/publisherPrefixService";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { useModal } from "../../utils/useModal";
import { getErrorCode } from "../../utils/getErrorCode";
import { createDeclareLastUsedNumberSchema } from "../../utils/validationUtils";
import { PublisherPrefixStatusEnum, } from "../../types/Api";
import { ErrorType } from "../../types/ErrorType";
var DECLARE_ERROR_CODES = [
    ErrorType.LAST_USED_NUMBER_INVALID,
    ErrorType.LAST_USED_NUMBER_NOT_IN_PREFIX,
    ErrorType.PREFIX_DECLARATION_PENDING,
    ErrorType.DECLARATION_NOT_ALLOWED,
];
export var PublisherPrefixDeclareLastUsed = function () {
    var _a;
    var history = useHistory();
    var location = useLocation();
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var formatMessage = useIntl().formatMessage;
    var _b = useModal(), isErrorOpen = _b.isOpen, errorMessage = _b.message, openErrorModal = _b.openModal, closeErrorModal = _b.closeModal;
    var _c = useState(null), result = _c[0], setResult = _c[1];
    var prefixId = new URLSearchParams(location.search).get("id");
    var _d = useQuery(["publisherPrefix", prefixId], function () { return fetchPublisherPrefixById(ky, prefixId); }, { enabled: !!prefixId }), publisherPrefix = _d.data, isLoading = _d.isLoading, isError = _d.isError;
    var _e = useForm({
        resolver: zodResolver(createDeclareLastUsedNumberSchema(formatMessage)),
        defaultValues: { lastUsedNumber: "", noNumberUsed: false },
        mode: "onBlur",
    }), handleSubmit = _e.handleSubmit, control = _e.control, watch = _e.watch, setValue = _e.setValue, errors = _e.formState.errors;
    var noNumberUsed = watch("noNumberUsed");
    var declareMutation = useMutation(function (values) {
        var _a;
        return declareLastUsedNumber(ky, prefixId, {
            lastUsedNumber: values.noNumberUsed
                ? undefined
                : (_a = values.lastUsedNumber) === null || _a === void 0 ? void 0 : _a.trim(),
            noNumberUsed: values.noNumberUsed,
        });
    }, {
        onSuccess: function (data) {
            setResult(data);
            queryClient.invalidateQueries(["publisherPrefix", prefixId]);
            queryClient.invalidateQueries(["publisher-prefixes"]);
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var code, messageId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorCode(error)];
                    case 1:
                        code = _a.sent();
                        messageId = code && DECLARE_ERROR_CODES.includes(code)
                            ? "ui-br-agency.publisher-prefix.declare.error.".concat(code)
                            : "ui-br-agency.publisher-prefix.declare.error.generic";
                        openErrorModal(formatMessage({ id: messageId }));
                        return [2 /*return*/];
                }
            });
        }); },
    });
    if (!prefixId || isError) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({ id: "ui-br-agency.modal.label.error" }) },
                React.createElement("p", null, formatMessage({
                    id: prefixId
                        ? "ui-br-agency.publisher-prefix.not.found"
                        : "ui-br-agency.publisher-prefix.id.not.provided",
                })),
                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return history.goBack(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    if (isLoading || !publisherPrefix)
        return null;
    var prefixWasClosed = ((_a = result === null || result === void 0 ? void 0 : result.publisherPrefix) === null || _a === void 0 ? void 0 : _a.status) === PublisherPrefixStatusEnum.CLOSED;
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({ id: "ui-br-agency.publisher-prefix.declare.pane.title" }, { value: publisherPrefix.value }), footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { buttonStyle: "primary", onClick: handleSubmit(function (values) {
                        return declareMutation.mutate(values);
                    }), disabled: declareMutation.isLoading },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.save" })), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: function () { return history.goBack(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" })) }) },
            React.createElement(MessageBanner, { type: "warning" },
                React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefix.declare.intro" })),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, md: 6 },
                    React.createElement(Controller, { name: "lastUsedNumber", control: control, render: function (_a) {
                            var _b;
                            var field = _a.field;
                            return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.publisher-prefix.declare.field.lastUsedNumber", disabled: noNumberUsed, error: (_b = errors.lastUsedNumber) === null || _b === void 0 ? void 0 : _b.message })));
                        } }))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(Controller, { name: "noNumberUsed", control: control, render: function (_a) {
                            var field = _a.field;
                            return (React.createElement(Checkbox, { checked: field.value, onChange: function (e) {
                                    field.onChange(e.target.checked);
                                    if (e.target.checked)
                                        setValue("lastUsedNumber", "");
                                }, label: formatMessage({
                                    id: "ui-br-agency.publisher-prefix.declare.field.noNumberUsed",
                                }) }));
                        } })))),
        React.createElement(Modal, { open: result !== null, label: formatMessage({ id: "ui-br-agency.modal.heading.result" }), footer: React.createElement(Button, { buttonStyle: "primary", onClick: function () { return history.push("/bragency/publisher-prefixes"); } },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.close" })) }, result ? (React.createElement(React.Fragment, null,
            React.createElement("p", null, result.blockedCount +
                result.alreadyBlockedCount +
                result.createdCount +
                result.skippedAssignedCount ===
                0 ? (React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefix.declare.success.noneUsed" })) : (React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefix.declare.success", values: {
                    blocked: result.blockedCount,
                    alreadyBlocked: result.alreadyBlockedCount,
                    created: result.createdCount,
                    skippedAssigned: result.skippedAssignedCount,
                } }))),
            result.unblockedCount > 0 && (React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefix.declare.success.unblocked", values: { unblocked: result.unblockedCount } }))),
            prefixWasClosed && (React.createElement(MessageBanner, { type: "warning" },
                React.createElement(FormattedMessage, { id: "ui-br-agency.publisher-prefix.declare.success.closed" }))))) : ("")),
        React.createElement(ErrorModal, { open: isErrorOpen, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: errorMessage, onClose: closeErrorModal })));
};
